/**
 * gufuyan
 * @content 设置主题颜色
 * @date 2017-05-11 2.0版本
 * @param props
 * @constructor
 */
import React from 'react';

/*
 * Horizontal横向 h
 * center中间 c
 * Unfolded展开 u
 * delay延迟,停顿 d
 * */
const animations = {
    h_l_u : {
        def : {
            transform:"scaleX(0)",
            transformOrigin:"0 50%"
        },
        move : {
            transform: "scaleX(1)"
        },
        cli : {
            transform: "scaleX(1)",
            transformOrigin:"50% 0"
        }
    },
    h_r_u : {
        def : {
            transform:"scaleX(0)",
            transformOrigin:"100% 50%"
        },
        move : {
            transform: "scaleX(1)"
        }
    },
    h_t_u : {
        def : {
            transform:"scaleY(0)",
            transformOrigin:"50% 0"
        },
        move : {
            transform: "scaleY(1)"
        }
    },
    h_b_u : {
        def : {
            transform:"scaleY(0)",
            transformOrigin:"50% 100%"
        },
        move : {
            transform: "scaleY(1)"
        }
    },

    h_l_u_d: {
        def : {
            transform:"scaleX(0)",
            transformOrigin:"0 50%"
        },
        move : {
            transform: "scaleX(1)",
            transitionTimingFunction: "cubic-bezier(0.52, 1.64, 0.37, 0.66)"
        }
    },
    h_r_u_d : {
        def : {
            transform:"scaleX(0)",
            transformOrigin:"100% 50%"
        },
        move : {
            transform: "scaleX(1)",
            transitionTimingFunction: "cubic-bezier(0.52, 1.64, 0.37, 0.66)"
        }
    },
    h_t_u_d : {
        def : {
            transform:"scaleY(0)",
            transformOrigin:"50% 0"
        },
        move : {
            transform: "scaleY(1)",
            transitionTimingFunction: "cubic-bezier(0.52, 1.64, 0.37, 0.66)"
        }
    },
    h_b_u_d : {
        def : {
            transform:"scaleY(0)",
            transformOrigin:"50% 100%"
        },
        move : {
            transform: "scaleY(1)",
            transitionTimingFunction: "cubic-bezier(0.52, 1.64, 0.37, 0.66)"
        }
    },

    h_c_o_u : {
        def : {
            transform:"scale(0)",
            transformOrigin:"50%"
        },
        move : {
            transform: "scale(1)"
        },
        cli : {
            transform:"scale(-1)",
            transformOrigin:"20%"
        }
    },
    h_o_c_u : {
        def : {
            transform:"scale(1)",
            transformOrigin:"50%"
        },
        move : {
            transform: "scale(0)"
        }
    },

    h_c_o_ch : {
        def : {
            transform:"scaleX(1)",
            transformOrigin:"50%"
        },
        move : {
            transform: "scaleX(0)"
        }
    },
    h_c_ch_o : {
        def : {
            transform:"scaleX(0)",
            transformOrigin:"50%"
        },
        move : {
            transform: "scaleX(1)"
        }
    },
    h_c_o_cx : {
        def : {
            transform:"scaleY(1)",
            transformOrigin:"50%"
        },
        move : {
            transform: "scaleY(0)"
        }
    },
    h_c_cx_o : {
        def : {
            transform:"scaleY(0)",
            transformOrigin:"50%"
        },
        move : {
            transform: "scaleY(1)"
        }
    },

};

export {animations};
